/**
 * ControlsUI (zero element caching)
 * ---------------------------------
 * - Reads elements via DOM.get(Selector.*) on-the-fly (no stored refs)
 * - Applies defaults from `config`
 * - Binds 'input' (continuous) and 'change' (release)
 * - Keeps only handler functions to unbind cleanly
 */
import { DOM } from './DOM.js'
import { Selector } from './Selectors.js'
import Utils from '../Utils.js'

export default class ControlsUI {
    constructor({ toolManager, config }) {
        this.toolManager = toolManager
        this.config = config
        this.handlers = {}
    }

    init() {
        this.applyDefaults()
        this.bindEvents()
        Utils?.hideAllSlider?.()
    }

    destroy() {
        const H = this.handlers
        this.off(DOM.get(Selector.sliderOpacity), 'input', H.onOpacityInput)

        this.off(DOM.get(Selector.sliderWheel), 'input', H.onWheelInput)
        this.off(DOM.get(Selector.sliderWheel), 'change', H.onWheelChange)

        this.off(DOM.get(Selector.sliderRotate), 'input', H.onRotateInput)
        this.off(DOM.get(Selector.sliderScale), 'input', H.onScaleInput)

        this.off(DOM.get(Selector.sliderBrush), 'input', H.onBrushInput)
        this.off(DOM.get(Selector.sliderBrush), 'change', H.onBrushChange)

        this.handlers = {}
    }

    applyDefaults() {
        const set = (el, cfg) => el && cfg && Object.assign(el, cfg)
        set(DOM.get(Selector.sliderOpacity), this.config?.opacity)
        set(DOM.get(Selector.sliderWheel), this.config?.wheel)
        set(DOM.get(Selector.sliderRotate), this.config?.rotate)
        set(DOM.get(Selector.sliderScale), this.config?.scale)
        set(DOM.get(Selector.sliderBrush), this.config?.brush)
    }

    bindEvents() {
        const tm = this.toolManager

        this.handlers.onOpacityInput = () => tm.sliderOpacity()

        this.handlers.onWheelInput = () => tm.sliderDiffuser(false)
        this.handlers.onWheelChange = () => tm.sliderDiffuser(true)

        this.handlers.onRotateInput = () => tm.sliderRotate()
        this.handlers.onScaleInput = () => tm.sliderScale()

        this.handlers.onBrushInput = () => {
            tm.sliderBrushSize()
            tm.sliderBrushCursorIcon()
        }
        this.handlers.onBrushChange = () => {
            tm.sliderBrushSize()
            tm.sliderBrushCursorIcon()
        }

        this.on(DOM.get(Selector.sliderOpacity), 'input', this.handlers.onOpacityInput, { passive: true })

        this.on(DOM.get(Selector.sliderWheel), 'input', this.handlers.onWheelInput, { passive: true })
        this.on(DOM.get(Selector.sliderWheel), 'change', this.handlers.onWheelChange)

        this.on(DOM.get(Selector.sliderRotate), 'input', this.handlers.onRotateInput, { passive: true })
        this.on(DOM.get(Selector.sliderScale), 'input', this.handlers.onScaleInput, { passive: true })

        this.on(DOM.get(Selector.sliderBrush), 'input', this.handlers.onBrushInput, { passive: true })
        this.on(DOM.get(Selector.sliderBrush), 'change', this.handlers.onBrushChange)
    }

    on(el, type, fn, opts) {
        if (el && fn) el.addEventListener(type, fn, opts)
    }
    off(el, type, fn) {
        if (el && fn) el.removeEventListener(type, fn)
    }
}
